import React from 'react'
import { Helmet } from 'react-helmet-async'
import { PublicLinkPasswordLayout } from '../../layouts'

const PublicLinkPasswordPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Authentication - Imagekit</title>
      <meta name="description" content="Public sharing authentication" />
    </Helmet>
    <PublicLinkPasswordLayout />
  </React.Fragment>
)

export default PublicLinkPasswordPage
